(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
(function ($) {
  $.fn.dateSelect = function (initialDate) {

    if (initialDate === 'destroy') {

      this.each(function (index, element) {
        $(element).datetimepicker('destroy')
      })

      $('#ui-datepicker-div').remove()

      return this
    }

    return this.datepicker(
      { dateFormat: 'dd MM yy'
      , showOtherMonths: true
      , changeYear: true
      , changeMonth: true
      , yearRange: 'c-100:c'
      }
    ).datepicker('setDate', initialDate).attr('readonly', true)
  }
})(jQuery)

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/dateSelect.jquery.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL2RhdGVTZWxlY3QuanF1ZXJ5LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsiKGZ1bmN0aW9uICgkKSB7XG4gICQuZm4uZGF0ZVNlbGVjdCA9IGZ1bmN0aW9uIChpbml0aWFsRGF0ZSkge1xuXG4gICAgaWYgKGluaXRpYWxEYXRlID09PSAnZGVzdHJveScpIHtcblxuICAgICAgdGhpcy5lYWNoKGZ1bmN0aW9uIChpbmRleCwgZWxlbWVudCkge1xuICAgICAgICAkKGVsZW1lbnQpLmRhdGV0aW1lcGlja2VyKCdkZXN0cm95JylcbiAgICAgIH0pXG5cbiAgICAgICQoJyN1aS1kYXRlcGlja2VyLWRpdicpLnJlbW92ZSgpXG5cbiAgICAgIHJldHVybiB0aGlzXG4gICAgfVxuXG4gICAgcmV0dXJuIHRoaXMuZGF0ZXBpY2tlcihcbiAgICAgIHsgZGF0ZUZvcm1hdDogJ2RkIE1NIHl5J1xuICAgICAgLCBzaG93T3RoZXJNb250aHM6IHRydWVcbiAgICAgICwgY2hhbmdlWWVhcjogdHJ1ZVxuICAgICAgLCBjaGFuZ2VNb250aDogdHJ1ZVxuICAgICAgLCB5ZWFyUmFuZ2U6ICdjLTEwMDpjJ1xuICAgICAgfVxuICAgICkuZGF0ZXBpY2tlcignc2V0RGF0ZScsIGluaXRpYWxEYXRlKS5hdHRyKCdyZWFkb25seScsIHRydWUpXG4gIH1cbn0pKGpRdWVyeSlcbiJdfQ==